module.exports = "/images/Acquire new customers.svg?7d4a22a8d484f125996c98e6d08da682";